// Import model
import { DataviewPickListResponse } from '../models/DataviewPickListResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterPickListRequest } from '../models/FilterPickListRequest';
import { PickList } from '../models/PickList';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterPickListRequestSerializer } from './FilterPickListRequestSerializer';
import { PickListSerializer } from './PickListSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewPickListResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewPickListResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewPickListResponse instance
   */
  static deserialize(json: string): DataviewPickListResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewPickListResponse instance
   */
  static fromObject(obj: any): DataviewPickListResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewPickListResponse');
    }


    const instance: DataviewPickListResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        PickListSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterPickListRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewPickListResponse instances
   */
  static deserializeArray(json: string): DataviewPickListResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewPickListResponse instance to a JSON string
   */
  static serialize(instance: DataviewPickListResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewPickListResponse instance to a plain object
   */
  static toObject(instance: DataviewPickListResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        PickListSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterPickListRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewPickListResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewPickListResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
